<template>
  <div id="app">
    <div class="headline">
      <h1>Dr. Ulrike Fischer</h1>
      <h2>Fach&auml;rztin f&uuml;r Orthop&auml;die</h2>
      <ul>
        <li>Sportmedizin</li>
        <li>Chirotherapie</li>
        <li>Akupunktur</li>
      </ul>
    </div>
    <div id="nav">
      <router-link to="/">Start</router-link>
      <router-link to="/leistungen">Leistungen</router-link>
      <router-link to="/anfahrt">Standort</router-link>
      <router-link to="/bilder">Bilder</router-link>
      <!--<router-link to="/galerie">Galerie</router-link>-->
    </div>
    <!--<div id="wallpaper"></div>-->
    <div id="content">
      <router-view/>
    </div>
    <div id="footline"></div>
    <sidebar></sidebar>
    <div id="footline">
      <router-link to="/impressum">Impressum</router-link>
    </div>
  </div>
</template>

<script>
import Sidebar from "@/components/Sidebar";

export default {
  components: {
    Sidebar
  }
};
</script>


<style lang="scss">
$blue: #b1d0e3;
$dark-blue: #7faac3;
$light-blue: #dbecf6;
$grey: #757575;
$light-grey: #e8e8e8;

html,
body {
  margin: 0px;
  padding: 0px;
  color: $grey;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.headline {
  background: white;
  text-align: center;
  padding: 5px;
  margin: 0px;
  display: block;
  h1,
  h2 {
    margin: 0px;
    padding: 0px;
  }

  ul {
    padding: 0px;
    margin: 0px;
    li {
      display: inline-block;
      margin-left: 5px;
      margin-right: 5px;
    }
  }
}

#nav {
  background: $light-grey;
  background-image: url("/images/wallpaper.jpg");
  background-repeat: no-repeat;
  background-position: 50% 53%;
  background-size: 100%;
  padding-top: 10px;
  text-align: right;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;

  a {
    flex-shrink: 1;
    text-decoration: none;
    color: white;
    background: $grey;
    padding: 20px;
    font-weight: bold;
    &.router-link-exact-active {
      color: $grey;
      background: white;
    }
  }
}

#flexbox {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  #content {
    flex-grow: 1;
  }

  #sidebar {
    flex-grow: 0;
  }
}

#footline {
  background: #c1101a;
  min-height: 5px;
  padding-right: 25px;
  text-align: right;
  a {
    color: white;
    text-decoration: none;
  }
}
</style>
